import React, {
    useState,
    useEffect,
    useRef,
} from 'react';
import { useSelector } from 'react-redux';
import instance from '../../../../helpers/axiosInstance';
import { Link, useNavigate } from 'react-router-dom';
import Search from '../../../../assets/Iconsearch.svg';
import Calandar from '../../../../assets/Icondate.svg';
// import FraudFilter from '../../../../assets/fraud-icon.png';
import AllFilter from '../../../../assets/filter-icon.png';
import DataGridPagination from '../../../global/dataGridPagination';
// import Moment from 'react-moment';
import moment from 'moment';
// import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
// import Popover from 'react-bootstrap/Popover';
// import actionButton from '../../../../assets/action-button.png';
import DateRangePicker from 'react-bootstrap-daterangepicker';
import 'bootstrap-daterangepicker/daterangepicker.css';
import FilterMenu from "../../../global/filterComponent/FilterMenu";
import CallStatus from '../../../global/popupModal/CallStatus';
import { filterOptions } from './filterObj';
import './newOrder.scss';
import { commonServiceMethod } from '../../../../helpers/helper';
import Loader from '../../../global/loader';
import SuccessToast from '../../../customToast/SuccessToast';
import { Slide, toast } from 'react-toastify';
// import CloseIcon from '../../../../assets/close -Icon.png';
import { Popup } from '../../../global/popupModal/BottomDialog';
import ErrorToast from '../../../customToast/ErrorToast';
// import refreshIcon from '../../../assets/dashboard/refreshIcon.png';

const PrintedOrderBody = () => {
    let navigate = useNavigate();
    const userClaim = useSelector((state) => state.user);
    const gridRef = useRef();
    const [rowData, setRowData] = useState([]);
    const [originalData, setOriginalData] = useState({});
    const [selectedObject, setSelectedObject] = useState([]);
    const [open, setOpen] = useState(false);

    // pagination and Filtr variables 
    const per_page = 50;
    const [pageNo, setPageNo] = useState(1);
    // moment().subtract(30, 'days').toDate(), moment().toDate()
    const [startDate, setStartDate] = useState(moment().subtract(30, 'days').toDate())
    const [endDate, setEndDate] = useState(moment().toDate());
    const [searchText, setSearchText] = useState("");
    const [isOpen, setIsOpen] = useState(false);

    const [loader, setLoader] = useState(false);
    // const [callRowID, setCallRowID] = useState('');
    const [popupData, setPopupData] = useState({ popupName: "", data: "", callBackMethod: null })
    const [, setSearchParam] = useState("");
    const [columnData, setComlumnData] = useState([]);
    const toggleDropdown = () => {
        setIsOpen(!isOpen);
        //console.log(isOpen);
    };


    let columnDefsWithCall = [
        {
            headerName: 'Order Id',
            field: 'order_name',
            headerCheckboxSelection: true,
            checkboxSelection: true,
            wrapText: true,
            autoHeight: true,
            width: 180,
            cellClass: "check-box-container order-number",
            cellRenderer: (param) => {
                // let productNames = param.data.orderProducts;
                //console.log(productNames, param.value)
                return (<div>
                    <Link className='grid-link' to={`/orders/all-order/order-details/${btoa(param.data?.order_id)}`}>{param.value}</Link>
                    {/* <p className='font-insetMedium order-date'><Moment format={"DD MMM YYYY hh:mm A"}>{param.data?.order_created_at}</Moment> </p>
                    <OverlayTrigger rootClose={true} trigger="click" placement="bottom" overlay={
                        <Popover id="popover-basic" className='z-index-2000 produc-list'>
                            <Popover.Body>
                                {productNames?.map((i, j) => <div key={j} className='product-list-container'>
                                    <p className='p-name bold'><b>{i.product_name}</b></p>
                                    <p className='p-sku'>SKU <b>{i.sku}</b></p>
                                    <p className='p-qty'>QTY <b>{i.quantity}</b></p>
                                </div>)}
                            </Popover.Body>
                        </Popover>
                    }>
                        <p className='viewMore'>
                            View Products
                        </p>
                    </OverlayTrigger> */}
                </div>)
            }
        },
        {
            field: 'app_order_status',
            width: 120,
            wrapText: true,
            autoHeight: true,
            headerName: 'Order Status',
            cellClass: "app-order-status",
            cellRenderer: (params) => {
                let order_status_class = "";
                if (params.value.toLowerCase() === "cancel") {
                    order_status_class = "cancel";
                } else if (params.value.toLowerCase() === "refunded") {
                    order_status_class = "refund";
                } else if (params.value.toLowerCase() === "delivered") {
                    order_status_class = "delivered";
                } else {
                    order_status_class = "";
                }
                return (<span className={`default-status ${order_status_class}`}>
                    {params.value}
                </span>)
            }
        },
        {
            width: 170,
            field: 'shipping_address',
            wrapText: true,
            autoHeight: true,
            headerName: 'Recipient',
            cellClass: "d-flex-center customers",
            cellRenderer(params) {
                let address = params.data?.shipping_address;
                return (
                    <div className="address-wrap">
                        <p className="customer-name">
                            {params.data?.customer_name}
                        </p>
                        <p className="address">
                            {params.data?.customer_email}
                        </p>
                        <p className="address">
                            {address.phone ? address.phone : ''}
                        </p>
                        <p className="address">
                            {address.city ? address.city : ''} - {address.zip ? address.zip : ''}
                        </p>
                    </div>
                )
            }
        },
        {
            headerName: 'Order Total',
            field: 'total_price',
            width: 100,
            cellClass: "d-flex-center",
            cellRenderer(params) {
                let payment_mode = "";
                let payment_status = "";
                if (params.data?.gateway === "Cash on Delivery (COD)") {
                    payment_mode = "COD";
                    payment_status = "info";
                } else {
                    payment_mode = "Pre-paid";
                    payment_status = "success";
                }
                return (
                    <div className='address-wrap'>
                        <p className="price_tag">{"Rs. " + params.value}</p>
                        <p className="price_tag">
                            <span className={payment_status}>{payment_mode}</span>
                        </p>
                    </div>
                )
            }
        },
        {
            field: 'carrier_name',
            width: 100,
            wrapText: true,
            autoHeight: true,
            headerName: 'Carrier',
            cellClass: "carrier-data",
        },
        {
            width: 100,
            field: 'order_created_at',
            wrapText: true,
            autoHeight: true,
            headerName: 'Order Date',
            cellClass: 'order-date',
            cellRenderer(param) {
                return (<span className={`order-date`}>{moment(param.value).format("MMM DD, YYYY hh:mm")}</span>)
            }
        },
        {
            width: 120,
            field: 'order_fulfillment_status',
            wrapText: true,
            autoHeight: true,
            headerName: 'Fulfilment Status',
            cellClass: 'order-fulfillment-status',
            cellRenderer(param) {
                return (<span className={`status-value ${param.value}`}>{param.value}</span>)
            }
        },
        {
            width: 230,
            field: 'product_name',
            wrapText: true,
            autoHeight: true,
            headerName: 'Item Name',
            cellClass: 'product-name',
            cellRenderer(param) {
                return (<span title={param.value} className={`status-value ${param.value}`}>{param.value}</span>)
            }
        },
        {
            width: 130,
            field: 'sku',
            wrapText: true,
            autoHeight: true,
            headerName: 'Item SKU',
            cellClass: 'sku-item',
            cellRenderer(param) {
                return (<span className={`status-value ${param.value}`}>{param.value}</span>)
            }
        },
    ];

    const [refreshData, setRefreshData] = useState(1);
    const [preSelectedOption, setPreSelectedOption] = useState({})

    useEffect(() => {
        if (userClaim.token !== "") {
            // getData(pageNo, moment(startDate).format('YYYY-MM-DD'), moment(endDate).format('YYYY-MM-DD'), searchText);
            setComlumnData([...columnDefsWithCall]);
        }
    }, [userClaim]);

    const onClearFilter = () => {
        setSearchText("");
        setSearchParam("");
        toggleDropdown();
        // getData(pageNo, moment(startDate).format('YYYY-MM-DD'), moment(endDate).format('YYYY-MM-DD'), "", "");
        navigate(`${location.pathname}`);
    }
    const showModal = (popupName, data, callBackMethod) => {

        // //console.log(string, value);
        // setCallDetails(string);
        // setCallRowID(value)
        setPopupData({ popupName, data, callBackMethod })
    }

    const closeModal = () => {
        // setCallDetails('');
        setPopupData({ popupName: "", data: "", callBackMethod: null });
    }


    // const handleStatusChange = (val, obj) => {
    //     //console.log(val, obj)
    //     setCallStatus(val, obj);
    // }

    // const setCallStatus = async (status, item) => {
    //     let url = `app/order/update/callStatus`;
    //     let obj = {};
    //     obj.order_id = item.order_id;
    //     obj.status = status.status;
    //     obj.reason_text = status.other;
    //     try {
    //         setLoader(true);
    //         await instance.put(url, obj).then((res) => {
    //             if (res.status === 200 && res?.data?.message === "Update order sucessfully") {
    //                 closeModal();
    //                 // const updatedRecord = rowData.map(i => {
    //                 //     if (i.order_id === item.order_id) {
    //                 //         i.callStatus = status.status;
    //                 //         i.reason_text = status.other;
    //                 //     }
    //                 //     return i
    //                 // });
    //                 // setRowData([...updatedRecord]);
    //                 getData(pageNo, moment(startDate).format('YYYY-MM-DD'), moment(endDate).format('YYYY-MM-DD'), searchText);
    //                 toast(<SuccessToast body={'Call status updated for Order ' + item.order_name} />, {
    //                     transition: Slide,
    //                     hideProgressBar: true,
    //                     autoClose: 2000,
    //                 });
    //             }
    //             setLoader(false);
    //         }).catch(e => {
    //             setLoader(false);
    //             console.error(e);
    //         })
    //     }
    //     catch (e) {
    //         setLoader(false);
    //         console.error(e);
    //     }
    // }
    // const getData = async (
    //     page = 1,
    //     startDate,
    //     endDate,
    //     searchText,
    //     perams = searchParam
    // ) => {
    //     var rowData = [];
    //     setLoader(true);
    //     if (searchText !== "") {
    //         if (/^\d{10}$/.test(searchText)) {
    //             searchText += '&orderDetails=m'
    //         }
    //         else if (searchText.match(
    //             /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    //         )) {
    //             searchText += '&orderDetails=e'
    //         }
    //         else {
    //             searchText += '&orderDetails='
    //         }
    //     }
    //     try {
    //         await instance.get(`app/order/getOrder?per_page=${per_page}&page=${page}&order_date=${startDate}&end_order_date=${endDate}&search=${searchText}&type=print${perams}`).then((res) => {

    //             //console.log(res);
    //             if (res.status === 200 && Array.isArray(res?.data?.orders)) {
    //                 setRowData(res?.data?.orders || []);
    //                 setOriginalData(res?.data)
    //             }
    //             setLoader(false);
    //         }).catch(e => {
    //             setLoader(false);
    //             console.error(e);
    //             setRowData([]);
    //         })
    //     }
    //     catch (e) {
    //         setLoader(false);
    //         console.error(e);
    //         setRowData([]);
    //     }
    //     return rowData;
    // }

    const handlePageClick = (event) => {
        setPageNo(event.selected + 1);
        var searchParams = new URLSearchParams(location.search);
        searchParams.set("page", event.selected + 1)
        navigate(`${location.pathname}?${searchParams.toString()}`);

    }

    const onCellClick = (e) => {
        let selectedITem = e.api.getSelectedRows();
        //console.log(selectedITem.length > 0)
        // setSelectedObject((selectedObject) => [...selectedObject]);
        selectedITem.length > 0 ? (setOpen(true), setSelectedObject([...selectedITem])) : (setOpen(false), setSelectedObject([]));
    }
    const dateChangeEvent = (date) => {
        setStartDate(date.startDate.format('YYYY-MM-DD'));
        setEndDate(date.endDate.format('YYYY-MM-DD'));
        var searchParams = new URLSearchParams(location.search);
        searchParams.set("order_date", date.startDate.format('YYYY-MM-DD'));
        searchParams.set("end_order_date", date.endDate.format('YYYY-MM-DD'));
        searchParams.set("page", 1);
        navigate(`${location.pathname}?${searchParams.toString()}`);
        
    }
    const searchTextChangeEvent = (e) => {
        e.preventDefault();
        var searchParams = new URLSearchParams(location.search);
        searchParams.set("search", searchText);
        searchParams.set("page", 1);
        navigate(`${location.pathname}?${searchParams.toString()}`);
        
    }

    const onApplyFilter = (selectionOption, searchTextval = "") => {
        var searchParams = new URLSearchParams(location.search);
        // console.log(selectionOption)
        let url = "";
        Object.keys(selectionOption).map(i => {
            searchParams.set(i, selectionOption[i]);
            url += `&${i}=${selectionOption[i]}`
        })
        searchParams.set("page", 1);
        searchParams.set("search", searchTextval);
        setSearchParam(url);
        localStorage.setItem("searchPeram", url);
        toggleDropdown();
        navigate(`${location.pathname}?${searchParams.toString()}`);
    }

    const closeExportPopup = () => {
        setOpen(false);
        setSelectedObject([])
        gridRef.current.api.deselectAll();
    }

    const printLabelMethod = (obj = []) => {
        obj = typeof obj.length === 'undefined' ? selectedObject : obj;
        const config = {
            headers: { Accept: "application/pdf" },
            responseType: "blob",
        };
        let objdata = obj.map((i) => i.order_id).join();
        commonServiceMethod(`app/pritnlabel`, "post", { order_id: objdata }, config, setLoader, (res) => {
            const blob = new Blob([res.data], { type: "application/pdf" });
            const objectUrl = window.URL.createObjectURL(blob);
            window.open(objectUrl);
            closeExportPopup();
        });
        setRefreshData((prev)=>prev+ 1);
    }

    const createManifestMethod = (obj) => {
        const config = {};
        obj = typeof obj.length === 'undefined' ? selectedObject : obj;
        let objdata = obj.map((i) => i.order_id).join();
        commonServiceMethod("app/create/manifest", "post", { order_id: objdata }, config, setLoader, (res) => {
            if (res.data.status_code === 200) {
                toast(<SuccessToast body={'Manifest created Sucessfully'} />, {
                    transition: Slide,
                    hideProgressBar: true,
                    autoClose: 2000,
                });
                setRefreshData((prev)=>prev+ 1);
                // getData(pageNo, moment(startDate).format('YYYY-MM-DD'), moment(endDate).format('YYYY-MM-DD'), searchText, searchParam);
                closeModal();
                closeExportPopup();
            }
        });
    }
    const unassignCarrierMethiod = (obj) => {
        const config = {};
        obj = typeof obj.length === 'undefined' ? selectedObject : obj;
        var objdata = "";
        objdata = obj.map((i) => i.order_id).join();
        commonServiceMethod("app/orders/unassign", "post", { order_id: objdata }, config, setLoader, (res) => {
            if (res.data.status_code === 200) {
                toast(<SuccessToast body={'Selected orders are unassigned successfully'} />, {
                    transition: Slide,
                    hideProgressBar: true,
                    autoClose: 2000,
                });
                // getData(pageNo, moment(startDate).format('YYYY-MM-DD'), moment(endDate).format('YYYY-MM-DD'), searchText, searchParam);
                setRefreshData((prev)=>prev+ 1);
                closeModal();
                closeExportPopup();
            }
        });
    }
    
    useEffect(() => {
        var searchParams = new URLSearchParams(location.search);
        let pageNo = searchParams.get("page") || 1;
        let fraudval = searchParams.get("filter") || "";
        let order_date = searchParams.get("order_date") || moment(startDate).format('YYYY-MM-DD');
        let end_order_date = searchParams.get("end_order_date") || moment(endDate).format('YYYY-MM-DD');
        let searchText = searchParams.get("search") || "";
        setSearchText(searchText);
        setPageNo(pageNo);
        searchParams.set("page", pageNo);
        if (fraudval === "") {
            searchParams.delete("filter");
        }
        else {
            searchParams.set("filter", fraudval);
        }
        setStartDate(order_date)
        setEndDate(end_order_date)
        searchParams.set("order_date", order_date);
        searchParams.set("end_order_date", end_order_date);
        searchParams.set("search", searchText);
        let obj = {};
        for (let [key, value] of searchParams.entries()) {
            obj[key] = value;
        }
        delete obj.end_order_date;
        delete obj.order_date;
        delete obj.page;
        // delete obj.search;
        setPreSelectedOption({ ...obj });
        // console.log("obj",obj)
        // let url = searchParams.toString() ? '&'+searchParams.toString()  : ""

        // console.log("URLProps", )
        navigate(`${location.pathname}?${searchParams.toString()}`);
        getGridData(searchParams.toString());
    }, [location.search, refreshData])

    const getGridData = async (param) => {
        var rowData = [];
        setLoader(true);
        try {
            await instance.get(`app/order/getOrder?per_page=${per_page}&type=print&${param}`).then((res) => {

                //console.log(res);
                if (res.status === 200 && Array.isArray(res?.data?.orders)) {
                    setRowData(res?.data?.orders || []);
                    setOriginalData(res?.data)
                }
                setLoader(false);
            }).catch(e => {
                setLoader(false);
                console.error(e);
                setRowData([]);
            })
        }
        catch (e) {
            setLoader(false);
            console.error(e);
            setRowData([]);
        }
        return rowData;
    }

    const syncOrder = () => {
        navigate(`${location.pathname}`);
    }

    const uploadBarcode = (data = []) => {
        const orders = (data || [])
            .filter((i) => {
                const oid = i.orderID ?? i.orderId;
                return oid != null && String(oid).trim() !== '';
            })
            .map((i) => ({
                orderID: String(i.orderID ?? i.orderId).trim(),
                dimensionValue:
                    i.dimensionValue != null && i.dimensionValue !== ''
                        ? String(i.dimensionValue)
                        : '',
            }));
        if (orders.length === 0) {
            toast(<ErrorToast body={'At least one order number is required'} />, {
                transition: Slide,
                hideProgressBar: true,
                autoClose: 2000,
            });
            return;
        }
        const config = {};
        commonServiceMethod("app/create/manifestByOrdernumbers", "post", { orders }, config, setLoader, (res) => {
            if (res.data.status_code === 200) {
                toast(<SuccessToast body={'Manifest Created Successfully'} />, {
                    transition: Slide,
                    hideProgressBar: true,
                    autoClose: 2000,
                });
                // getData(pageNo, moment(startDate).format('YYYY-MM-DD'), moment(endDate).format('YYYY-MM-DD'), searchText);
                setRefreshData((prev)=>prev+ 1);
                closeModal();
                closeExportPopup();
            }
            else {
                toast(<ErrorToast body={res.data.message} />, {
                    transition: Slide,
                    hideProgressBar: true,
                    autoClose: 2000,
                });
            }
        });
    }
    return (
        <>
            <div className='order-tabs'>

                <Loader showHide={loader} />
                <div className='quick-buttons'>
                    {/* <Link to={'/customers'} className='quickBtn' >Customer</Link>&nbsp;
                <Link to={'/products'} className='quickBtn' >Product</Link>&nbsp; */}

                    {/* {checkAccess(10) && <button className='quickBtn' onClick={() => showModal('quickAccess', 'quickAccess', quickAccessMethod)}> <img src={gridIcon} className="gridIcon"></img> Quick Actions</button>}
                <button className='syncBtn'> <img src={refreshIcon} className="refreshIcon"></img> Sync Orders</button> */}

                    {/* <button className='syncBtn' onClick={() => showModal('courierPartner', 'courierPartner')}>Assign Courier Partner</button>
                <button className='syncBtn' onClick={() => showModal('scanawb', 'scanawb')}>Scan/Paste AWBs</button> */}
                </div>
                <button onClick={() => syncOrder()} className='syncBtn' >Sync</button>
                {open ? <Popup className='all-order' show={{ printLabel: true, unassignCarrier: true, createManifest: true }} printLabelMethod={printLabelMethod} createManifestMethod={createManifestMethod} unassignCarrierMethiod={unassignCarrierMethiod} selecteObject={selectedObject} closePopup={() => { closeExportPopup(); }} /> : null}
                <div className='row filter-section'>
                    <div className="filter-left-container">
                        <div className="form-group">
                            <form onSubmit={searchTextChangeEvent}>
                                <div style={{ position: 'relative' }}>
                                    <span className="icon"><img alt='' src={Search} /></span>
                                </div>
                                <input
                                    type="text"
                                    id="filter-text-box"
                                    placeholder="Search"
                                    className='form-control inputWithIcon'
                                    value={searchText}
                                    onChange={(e) => setSearchText(e.target.value)}
                                />
                            </form>
                        </div>
                    </div>
                    <div className='filter-right-container'>
                        <div className='barcode'>
                            <button type='button' onClick={() => showModal('barcdoe-manifest', [], uploadBarcode)} className='btn btn-sm filter-btn barcodeManifest'> Barcode Manifest</button>
                        </div>

                        <div className='dropdown-dialog-parent me-2'>
                            <div className={` dropdown-dialog ${isOpen ? 'open' : ''}`}>
                                <button type='button' className='btn btn-sm  filter-btn' onClick={toggleDropdown} ><img alt='' style={{ width: 17 }} src={AllFilter} /> Filters</button>
                                <FilterMenu show={isOpen} preSelectedOption={preSelectedOption} filterOptions={filterOptions} onClear={onClearFilter} onApply={onApplyFilter}></FilterMenu>
                            </div>
                        </div>
                        <div className="form-group datepicker-class me-4">
                            <div style={{ position: 'relative' }}>
                                <span className="icon"><img alt='' src={Calandar} /></span>
                            </div>
                            <DateRangePicker
                                className="datepicker-custom"
                                initialSettings={
                                    {
                                        startDate: startDate,
                                        endDate: endDate,
                                        maxDate: moment().toDate(),
                                        showDropdowns: true,
                                        locale: {
                                            format: 'MMM DD, YYYY',
                                        },
                                        ranges: {
                                            Today: [moment().toDate(), moment().toDate()],
                                            Yesterday: [
                                                moment().subtract(1, 'days').toDate(),
                                                moment().subtract(1, 'days').toDate(),
                                            ],
                                            'Last 7 Days': [
                                                moment().subtract(6, 'days').toDate(),
                                                moment().toDate(),
                                            ],
                                            'Last 30 Days': [
                                                moment().subtract(30, 'days').toDate(),
                                                moment().toDate(),
                                            ],
                                            'This Month': [
                                                moment().startOf('month').toDate(),
                                                moment().endOf('month').toDate(),
                                            ],
                                            'Last Month': [
                                                moment().subtract(1, 'month').startOf('month').toDate(),
                                                moment().subtract(1, 'month').endOf('month').toDate(),
                                            ],
                                        },
                                    }}
                                onApply={(e, val) => dateChangeEvent(val, e)}
                            >
                                <input type="text" className="form-control datepicker-range" />
                            </DateRangePicker>
                        </div>

                    </div>
                    <p className='total-count'>Total Count: {originalData?.count}</p>
                </div >
                <DataGridPagination
                    rowData={rowData}
                    columnDefs={columnData}
                    onSelectionChanged={onCellClick}
                    gridref={gridRef}
                    rowSelection={"multiple"}
                    domLayout="autoHeight"
                    onPageChange={handlePageClick}
                    pageRangeDisplayed={originalData.per_page}
                    pageCount={originalData.count}
                    forcePage={pageNo-1}
                />
                {popupData.popupName !== "" &&
                    <CallStatus
                        item={popupData.data}
                        show={popupData.popupName}
                        handleSave={popupData.callBackMethod}
                        handleClose={closeModal}
                    />
                }

            </div>
        </>
    );
}

export default PrintedOrderBody;